import { Spinner } from '@heroui/react'
import { useMonthPeriodStore } from '../../store/useMonthPeriodStore'
import { StationPanelLinePhoto } from '../panels/StationPanelLinePhoto'
import { MonthPeriodPicker } from './shared/MonthPeriodPicker'
import { PhenomenaDayGrid } from './shared/PhenomenaDayGrid'
import { PhenomenaLegend } from './shared/PhenomenaLegend'
import { buildDayKeys } from './shared/phenomenaUtils'
import { TableOrientationToggle } from './shared/TableOrientationToggle'
import { useTableOrientationStore } from '../../store/useTableOrientationStore'
import { usePhenomenaDefinitions, usePhenomenaDayData } from '../../hooks/usePhenomenaData'

const SLUG = 'dly-jevy'

export function DlyJevyView({ station }) {
  const { year, month, setYear, setMonth } = useMonthPeriodStore()
  const orientation = useTableOrientationStore((s) => s.getOrientation(SLUG))

  const { defsMap, isLoading: defsLoading, isError: defsError } = usePhenomenaDefinitions()
  const { dayMap, isLoading: dayLoading, isError: dayError } = usePhenomenaDayData(station?.gh_id, year, month)

  const isLoading = defsLoading || dayLoading
  const isError = defsError || dayError

  const dayKeys = buildDayKeys(year, month)

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="p-4 border-b border-gray-200 bg-white flex flex-col gap-3">
        {station && <StationPanelLinePhoto station={station} />}
        <div className="flex items-center justify-between gap-3 flex-wrap">
          <MonthPeriodPicker
            year={year}
            month={month}
            onYearChange={setYear}
            onMonthChange={setMonth}
            obsType="DLY"
          />
          <TableOrientationToggle slug={SLUG} />
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-h-0 p-4 flex gap-6 overflow-auto">
        {isLoading && (
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <Spinner size="sm" /> Načítání dat…
          </div>
        )}
        {isError && (
          <p className="text-red-500 text-sm">Chyba při načítání dat</p>
        )}
        {!isLoading && !isError && (
          <>
            <PhenomenaDayGrid dayKeys={dayKeys} defsMap={defsMap} dayMap={dayMap} orientation={orientation} />
            <PhenomenaLegend defsMap={defsMap} />
          </>
        )}
      </div>
    </div>
  )
}
